module.exports = __webpack_public_path__ + "static/a-xx-227-art-f3e11de1539bcdf3775eb9c7f45dbc9c.jpg";